import {
  ActionIcon,
  Group,
  MultiSelect,
  MultiSelectProps,
  Select,
  SelectProps,
  Tooltip,
} from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';

import { useGetManyMedicalOrganizationsQuery } from '@api/medicalOrganizations.api';

type MedicalOrganizationsSelectorProps =
  | (Omit<
      SelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple?: false;
    })
  | (Omit<
      MultiSelectProps,
      'data' | 'searchable' | 'nothingFoundMessage' | 'placeholder'
    > & {
      multiple: true;
    });

export default function MedicalOrganizationsSelector(
  props: MedicalOrganizationsSelectorProps,
) {
  // ==========================================================================
  // Api
  // ==========================================================================
  const {
    data = [],
    isLoading,
    refetch,
  } = useGetManyMedicalOrganizationsQuery({
    sortBy: 'user.name',
    sortOrder: 'asc',
  });

  // ==========================================================================
  // Render
  // ==========================================================================
  return props.multiple ? (
    <MultiSelect
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna organizzazione trovata"
      placeholder={
        props.value?.length || 0 > 0
          ? undefined
          : 'Seleziona le organizzazioni mediche'
      }
      data={data.map((organization) => ({
        value: organization.id,
        label: organization.user.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  ) : (
    <Select
      {...props}
      label={
        <Group
          display="inline-flex"
          w="max-content"
          gap="0.2rem"
          align="center"
        >
          <Tooltip label="Ricarica opzioni">
            <ActionIcon size="1rem" variant="subtle" onClick={refetch}>
              <IconRefresh />
            </ActionIcon>
          </Tooltip>
          <span>{props.label}</span>
        </Group>
      }
      searchable
      nothingFoundMessage="Nessuna organizzazione trovata"
      placeholder="Seleziona l'organizzazione medica"
      data={data.map((organization) => ({
        value: organization.id,
        label: organization.user.name,
      }))}
      disabled={isLoading || props.disabled}
    />
  );
}
